export default __webpack_public_path__ + "static/australian-thermic-lance-company-tablet-cfcd1aed1469501de5cf600e839bd7a6.gif";